/* Quieto film: plays the four clips back to back like one short film, with a caption per
   chapter, story-style progress bars and a shoppable end frame. No scroll-jacking — the
   page scrolls normally; the film only plays while it is on screen. */
(function () {
  function mount(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var mobile = window.matchMedia('(max-width: 749px)').matches;
    var chapters = Array.prototype.map.call(root.querySelectorAll('[data-chapter]'), function (el) {
      return { el: el, src: mobile ? (el.dataset.srcM || el.dataset.src) : el.dataset.src };
    });
    var videos = root.querySelectorAll('video');
    var bars = root.querySelectorAll('[data-bar]');
    var endCard = root.querySelector('[data-end]');
    var toggle = root.querySelector('[data-toggle]');
    var replay = root.querySelector('[data-replay]');
    var hotspots = root.querySelectorAll('[data-spot]');
    var current = -1, active = 0, ended = false, paused = false, visible = false;

    function show(el, on) { el.classList.toggle('is-on', on); }
    function caption(i) { chapters.forEach(function (c, k) { show(c.el, k === i); }); }
    function setBars(i, frac) {
      bars.forEach(function (b, k) {
        var v = k < i ? 1 : (k === i ? frac : 0);
        b.style.transform = 'scaleX(' + v + ')';
      });
    }

    // Two stacked <video>s: the next clip is loaded in the hidden one so the hand-off has no gap.
    function load(v, i) {
      if (!chapters[i] || !chapters[i].src) return;
      if (v.dataset.idx === String(i)) return;
      v.dataset.idx = String(i);
      v.src = chapters[i].src;
      v.load();
    }
    function play(i) {
      ended = false;
      root.classList.remove('is-ended');
      show(endCard, false);
      current = i;
      var v = videos[active], old = videos[1 - active];
      load(v, i);
      v.currentTime = 0;
      caption(i);
      // No dip between clips: the outgoing clip stays fully opaque underneath until the
      // incoming one has actually painted a frame, then the new one fades in on top.
      v.style.zIndex = '2'; old.style.zIndex = '1';
      v.classList.remove('is-on');
      var shown = false;
      function reveal() {
        if (shown || videos[active] !== v) return;
        shown = true;
        v.classList.add('is-on');
        setTimeout(function () {
          if (videos[active] !== v) return;
          old.classList.remove('is-on');
          load(old, i + 1);
        }, 400);
      }
      if (v.requestVideoFrameCallback) v.requestVideoFrameCallback(reveal);
      v.addEventListener('playing', function () { setTimeout(reveal, 50); }, { once: true });
      var p = v.play();
      if (p && p.then) p.then(function () {}, function () {});
    }
    function next() {
      if (current + 1 >= chapters.length) return finish();
      active = 1 - active;
      play(current + 1);
    }
    function playing(on) { document.documentElement.classList.toggle('q-film-playing', on); }
    function finish() {
      // On phones the card would cover the end frame's offers; there it waits until the
      // visitor scrolls past the film (handled by the observer below).
      if (!mobile) playing(false);
      ended = true;
      root.classList.add('is-ended');
      setBars(chapters.length, 0);
      caption(-1);
      show(endCard, true);
    }

    videos.forEach(function (v) {
      v.muted = true; v.playsInline = true;
      v.addEventListener('ended', function () { if (v === videos[active]) next(); });
    });

    var spotsAt = parseFloat(root.dataset.spotsAt);
    function tick() {
      var v = videos[active];
      if (!ended && current >= 0 && v.duration) setBars(current, v.currentTime / v.duration);
      // Colour labels show up in the last chapter as soon as the hoods are in frame.
      root.classList.toggle('show-spots', ended || (current === chapters.length - 1 && v.currentTime >= spotsAt));
      requestAnimationFrame(tick);
    }

    bars.forEach(function (b, k) {
      b.closest('button').addEventListener('click', function () { paused = false; root.classList.remove('is-paused'); active = 1 - active; play(k); });
    });
    toggle.addEventListener('click', function () {
      if (ended) return;
      var v = videos[active];
      paused = !paused;
      root.classList.toggle('is-paused', paused);
      // Labels come translated from the section (data-label-play / data-label-pause).
    toggle.setAttribute('aria-label', paused ? toggle.dataset.labelPlay : toggle.dataset.labelPause);
      if (paused) v.pause(); else v.play();
    });
    replay.addEventListener('click', function () { active = 1 - active; play(0); });

    // Hotspots are authored in frame coordinates (0..1 of the 16:9 video); with object-fit:
    // cover the frame is scaled and cropped, so map them onto the actual box.
    function placeSpots() {
      var w = root.clientWidth, h = root.clientHeight, ar = 16 / 9;
      var vw = Math.max(w, h * ar), vh = vw / ar;
      var ox = (w - vw) / 2, oy = (h - vh) / 2;
      hotspots.forEach(function (s) {
        var x = ox + parseFloat(s.dataset.x) * vw, y = oy + parseFloat(s.dataset.y) * vh;
        s.style.left = x + 'px'; s.style.top = y + 'px';
        s.hidden = x < 16 || x > w - 16 || y < 16 || y > h - 16;
      });
    }
    window.addEventListener('resize', placeSpots);
    placeSpots();

    if (reduce) { finish(); root.classList.add('show-spots'); return; }

    caption(0);
    playing(true);
    // Safety net: never keep the consent card hidden for longer than the film itself.
    if (!mobile) setTimeout(function () { playing(false); }, 40000);
    var started = false;
    new IntersectionObserver(function (entries) {
      visible = entries[0].isIntersecting;
      if (!visible) { playing(false); if (!ended) videos[active].pause(); return; }
      if (!ended) playing(true);
      if (!started) { started = true; play(0); requestAnimationFrame(tick); return; }
      if (!ended && !paused) videos[active].play();
    }, { threshold: 0.5 }).observe(root);
  }

  function init() { document.querySelectorAll('[data-q-film]').forEach(mount); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
